import React from "react";
import { SingleSelect } from "designSystem/index";
import Text from "designSystem/components/text/Text";
import { sortedByGroupItems as originalGroupedItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const items = cloneDeep(originalGroupedItems);

	const itemsWithEmptyGroup = cloneDeep(items);
	itemsWithEmptyGroup.forEach((item) => item.group = item.group === "CA" ? "" : item.group);

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="All grouped" />
			<Text semiBold text="Some ungrouped items" />
			<Text semiBold text="Suggested" />
			<SingleSelect
				grouped
				options={items}
				value={items[0]}
			/>
			<SingleSelect
				grouped
				options={itemsWithEmptyGroup}
				value={items[0]}
			/>
			<SingleSelect
				grouped
				options={items}
				suggestedGroups={[ "CA", "WA" ]}
				value={items[0]}
			/>
		</CssColumnGrid>
	);
};